import { saveLog } from "./storage.js";
import { getCallTime } from "./callQueue.js";

export class DupoSystemLog {
  constructor(data) {
    this.log_data = data || [];
  }
  log(data) {
    let time = getCallTime();
    let logItem = { time, data };
    this.log_data.push(logItem)
    this.storeToCache(logItem);
  }
  storeToCache(logItem) {
    saveLog(logItem);
  }
  query(q) {
    return this.log_data.filter((d) => {
      let flag = true;
      Object.keys(q).forEach((key) => { if (q[key] !== d?.data[key]) flag = false; });
      return flag;
    })
  }
}

export function makeExternalLog(log, data) {
  log.update((log) => {
    log.log(data);
    return log
  });
}